<template>
    <v-container>
        <v-layout>
            <v-flex class="mt-4">
                <v-pagination
                        :length="10"
                        :total-visible="6"
                ></v-pagination>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "Pagination"
    }
</script>

<style scoped>

</style>